<template>
  <div class="login-container">
    <div class="login-main">
      <div class="login-header">
        <a href="http://www.spr-atm.com">
          <img src="@images/logo2.png" />
        </a>
        <div class="login">登录</div>
      </div>
      <el-card class="login-left">
        <div class="title-wrapper">
          <div class="title-zh">
            我们的服务
          </div>
          <div class="title-en">
            Our services
          </div>
        </div>
        <ul class="function-wrapper">
          <li>传统采购</li>
          <li>委托采购</li>
          <li>需求查询</li>
          <li>产品推荐</li>
        </ul>
      </el-card>
      <el-card class="login-right">
        <img
          src="@images/cooperation_lib_logo.png"
          alt="合作库-供应商查询系统"
        />
        <div class="title">
          合作库-供应商查询系统
        </div>
        <el-form
          :model="loginForm"
          :rules="loginFormRules"
          autoComplete="on"
          ref="loginFormRef"
        >
          <el-form-item prop="username" class="username-wrapper">
            <el-input
              placeholder="请输入用户名"
              v-model="loginForm.username"
              autoComplete="on"
              clearable
              size="mini"
              prefix-icon="iconfont icon-user"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password" class="password-wrapper">
            <el-input
              placeholder="请输入密码"
              type="password"
              autoComplete="on"
              clearable
              size="mini"
              v-model="loginForm.password"
              prefix-icon="iconfont icon-password"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <el-button
          class="login-btn"
          @click.prevent="login"
          :loading="isLoading"
        >
          供应商登录
        </el-button>

        <div class="btn-wrapper">
          <!-- <router-link to="/register"
                       class="register-btn">
            申请注册
          </router-link> -->
          <!-- <router-link to="/co_lib-login"
                       class="co-lib-btn">
            合作库登录
          </router-link> -->
          <router-link
            to="/user-login"
            class="user-login-btn"
            style="width:100%;"
          >
            VIP登录
          </router-link>
        </div>
        <div class="help-wrapper">
          <div class="forget-password" @click="handleForgetPassword">
            忘记密码
          </div>
          <span>|</span>
          <div class="register">
            <router-link to="/register">申请注册</router-link>
          </div>
        </div>
      </el-card>
    </div>
    <div class="login-footer">
      Copyright &copy; 2019-2026 深圳市森普瑞科技 版权所有
      <!-- <cnzz /> -->
    </div>

    <el-dialog
      class="tips-dialog"
      title="温馨提示！"
      :visible.sync="isShowTips"
      :before-close="handleClose"
      top="40vh"
      width="445px"
    >
      <p>
        忘记密码请您联系：
      </p>
      <p>
        QQ：2850559748
      </p>
      <p>
        电话：0755-82405890-8814
      </p>
      <p>
        邮箱：atm8814@spr-atm.com
      </p>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import qs from 'qs'
import OAuth from '@/plugins/OAuth.js'
import Cookies from 'js-cookie'
// import CNZZ from '@/components/public/CNZZ.vue'

export default {
  components: {
    // cnzz: CNZZ
  },
  data() {
    return {
      isLoading: false,
      isShowTips: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      redirectUrl: this.$route.query.redirectUrl || '/home'
    }
  },
  created() {},
  mounted() {},
  methods: {
    login() {
      this.$refs.loginFormRef.validate(valid => {
        if (valid) {
          if (this.isLoading) return
          this.isLoading = true
          OAuth.getToken(this.loginForm.username, this.loginForm.password)
            .then(res => {
              const auth = res.result.accessToken
              this.$message.success('登录成功！(Login Successfully!)')
              this.isLoading = false
              this.saveToken(auth)
              // 登录成功，跳转到主页
              this.$router.push({
                path: this.redirectUrl
              })
            })
            .catch(err => {
              this.$message.error('账号或密码错误！(Account or password incorrect!)')
              this.isLoading = false
            })
        }
      })
    },
    saveToken(auth) {
      this.$store.commit('setAuth', auth)
      Cookies.set('auth', JSON.stringify(auth))
    },
    handleForgetPassword() {
      // this.isShowTips = true
      this.$router.push({ path: '/forgetPassword/resetPassword' })
    },
    handleClose(done) {
      this.isShowTips = false
      done()
    }
  }
}
</script>
<style lang="less" scoped>
.login-container {
  height: 100%;
  min-height: 748px;
  position: relative;
  font-family: 'Source Han Sans CN';
  background: url('../assets/images/login_bg1.jpg') no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-main {
  width: 860px;
  height: 560px;
  position: relative;
}
.login-header {
  height: 50px;
  position: absolute;
  left: 0;
  top: -80px;
  display: flex;
  align-items: center;
  a {
    height: 100%;
    margin-right: 20px;
    cursor: pointer;
    img {
      height: 100%;
    }
  }
  .login {
    height: 100%;
    line-height: 50px;
    padding-left: 20px;
    border-left: 1px solid #e3ecf8;
    font-size: 25px;
    color: #f6f9fd;
  }
}
.login-left {
  background: url('../assets/images/login_bg2.jpg') no-repeat;
  width: 448px;
  height: 560px;
  box-shadow: 0px 16px 25px rgba(76, 99, 211, 0.54) !important;
  border: none;
  border-radius: 10px;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: 300;
  z-index: 5;
  /deep/ .el-card__body {
    width: 100%;
    height: 100%;
    padding: 0;
  }
  .title-wrapper {
    position: absolute;
    left: 30px;
    top: 40px;
    text-align: right;
    .title-zh {
      font-size: 28px;
      color: #ffffff;
      opacity: 0.9;
      padding-bottom: 15px;
      position: relative;
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        width: 40%;
        height: 1px;
        background: #ffffff;
      }
    }
    .title-en {
      margin-top: 10px;
      font-size: 12px;
      color: #ffffff;
      opacity: 0.5;
    }
  }
}
.function-wrapper {
  position: absolute;
  left: 56px;
  top: 140px;
  list-style: disc;
  li {
    list-style: disc;
    color: #ffffff;
    font-size: 16px;
    margin-top: 24px;
    opacity: 0.8;
    &:nth-child(2) {
      margin-left: 12px;
      opacity: 0.7;
    }
    &:nth-child(3) {
      margin-left: 24px;
      opacity: 0.6;
    }
    &:nth-child(4) {
      margin-left: 36px;
      opacity: 0.5;
    }
  }
}
.login-right {
  background-color: #ffffff;
  width: 420px;
  height: 520px;
  box-shadow: 0px 16px 20px rgba(76, 99, 211, 0.3);
  border-radius: 10px;
  position: absolute;
  right: 0;
  top: 20px;
  padding: 40px 60px 20px 68px;
  /deep/ .el-card__body {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 56px;
    height: 56px;
    margin-bottom: 10px;
  }
  .title {
    font-size: 20px;
    font-weight: 300;
    color: #4a62d0;
  }
}
.el-form {
  width: 100%;
  margin-top: 40px;
  .username-wrapper,
  .password-wrapper {
    width: 100%;
    border-bottom: 1px solid #99b9f2;
    /deep/ .iconfont {
      color: #99b9f2;
    }
    .el-input {
      /deep/ .el-input__inner {
        border: none;
        outline: none;
        input {
          border: none;
          outline: none;
        }
      }
      &::after {
        position: absolute;
        content: '*';
        top: -2px;
        left: -2px;
        color: #d36b75;
      }
    }
    /deep/ .el-form-item__content {
      line-height: 28px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #99b9f2 !important;
    }
    /deep/ input::-moz-placeholder {
      color: #99b9f2 !important;
    }
  }
}
.login-btn {
  height: 40px;
  width: 100%;
  margin-top: 10px;
  background: linear-gradient(
    91deg,
    rgba(76, 98, 210, 1) 0%,
    rgba(125, 168, 237, 1) 100%
  );
  box-shadow: 0px 5px 10px rgba(76, 99, 211, 0.3);
  border-radius: 10px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-wrapper {
  width: 100%;
  height: 40px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .co-lib-btn,
  .user-login-btn {
    width: 140px;
    height: 40px;
    border: 1px solid #99b9f2;
    border-radius: 8px;
    text-align: center;
    line-height: 40px;
    color: #7da8ed;
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: #f5f5f5;
      color: #5670d7;
    }
  }
}
.help-wrapper {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .forget-password {
    font-size: 14px;
    color: #99b9f2;
    bottom: 20px;
    user-select: none;
    cursor: pointer;
  }
  span {
    margin: 0 10px;
  }
  .register {
    font-size: 14px;
    cursor: default;
    a {
      color: #7da8ed;
      user-select: none;
      cursor: pointer;
    }
  }
}
.tips-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  p {
    font-family: 'Source Han Sans CN';
    text-indent: 2em;
    font-size: 14px;
    line-height: 24px;
  }
}
.login-footer {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 16px;
  color: #ffffff;
}
</style>
